/**
 * EasyR product page behaviour. Loaded by sections/main-product.liquid.
 *
 * - Add to cart with no size chosen: the button stays enabled (data-preselection-disabled="false"),
 *   so pressing it would post an empty variant id. Instead the theme's own form error box shows
 *   the button's data-easyr-select-error message, naming the first option still to choose. The
 *   message clears when a variant is chosen.
 * - Help panel (snippets/easyr-product-help.liquid): "Chat now" opens the Gorgias chat when it is
 *   loaded, and otherwise follows its link to the contact page.
 * - Size chart: Kiwi Sizing inserts its "Size Chart" link below the options. When it is there, the
 *   link on the size label line (snippets/easyr-size-chart-link.liquid) is shown, Kiwi's is hidden,
 *   and clicks on ours open Kiwi's chart. The options re-render on every variant change, so this
 *   re-runs whenever the page changes.
 */
(() => {
  const FLAG = 'easyrSelectError';

  /**
   * Returns the name of the first option with no value chosen, lower-cased for use mid-sentence.
   * @param {Element} section - The product section.
   * @returns {string}
   */
  const firstUnchosenOption = (section) => {
    const selectors = section.querySelectorAll('variant-picker .option-selector[data-option]');
    for (const selector of selectors) {
      if (!selector.querySelector('.js-option:is(:checked, [aria-selected="true"])')) {
        return selector.dataset.option.toLowerCase();
      }
    }
    return selectors.length ? selectors[0].dataset.option.toLowerCase() : '';
  };

  // Capture phase on the document, so this runs before the theme's product-form submit handler.
  document.addEventListener(
    'submit',
    (evt) => {
      const form = evt.target;
      if (!form.matches || !form.matches('.js-product-form-main')) return;
      if (!form.elements.id || form.elements.id.value !== '') return;

      const button = form.querySelector('[name="add"]');
      const errorBox = form.querySelector('.js-form-error');
      if (!button || !button.dataset.easyrSelectError || !errorBox) return;

      evt.preventDefault();
      evt.stopPropagation();

      const section = form.closest('.shopify-section') || document;
      errorBox.textContent = button.dataset.easyrSelectError.replace('[name]', firstUnchosenOption(section));
      errorBox.hidden = false;
      errorBox.dataset[FLAG] = 'true';

      const rect = errorBox.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > window.innerHeight) {
        errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    { capture: true }
  );

  document.addEventListener('on:variant:change', (evt) => {
    if (!evt.detail || !evt.detail.variant) return;
    document.querySelectorAll('.js-product-form-main .js-form-error').forEach((errorBox) => {
      if (errorBox.dataset[FLAG]) {
        errorBox.hidden = true;
        delete errorBox.dataset[FLAG];
      }
    });
  });

  const syncSizeChart = () => {
    document.querySelectorAll('.cc-main-product').forEach((section) => {
      const kiwi = section.querySelector('.ks-chart-container');
      const link = section.querySelector('[data-easyr-size-chart]');
      if (!kiwi || !link) return;
      link.hidden = false;
      kiwi.hidden = true;
    });
  };

  let syncQueued = false;
  new MutationObserver(() => {
    if (syncQueued) return;
    syncQueued = true;
    setTimeout(() => {
      syncQueued = false;
      syncSizeChart();
    }, 0);
  }).observe(document.documentElement, { childList: true, subtree: true });
  syncSizeChart();

  document.addEventListener('click', (evt) => {
    const sizeChart = evt.target.closest && evt.target.closest('[data-easyr-size-chart]');
    if (!sizeChart) return;
    const section = sizeChart.closest('.shopify-section') || document;
    const kiwiLink = section.querySelector('.ks-chart-modal-link');
    if (kiwiLink) kiwiLink.click();
  });

  document.addEventListener('click', (evt) => {
    const link = evt.target.closest && evt.target.closest('[data-easyr-open-chat]');
    if (!link || !window.GorgiasChat || typeof window.GorgiasChat.open !== 'function') return;
    evt.preventDefault();
    window.GorgiasChat.open();
  });
})();
